import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import SchemadrawApp from "./containers/Board";
import Login from "./containers/Login";
import Index from "./containers/Index";
import Manage from "./containers/Manage";
import Profile from "./containers/Profile";
import Animation from "./containers/Animation";
import Mermaid from "./containers/Mermaid";


import "./containers/pwa";
const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);
root.render(
  <BrowserRouter basename='/'>
    <Routes>
      <Route path='/login' element={<Login />} />
      <Route path='/draw/*' element={<SchemadrawApp />} />
      <Route path='/animate/*' element={<Animation />} />
      <Route path='/mermaid/*' element={<Mermaid />} />
      <Route path='/profile/*' element={<Profile />} />
      <Route path='/manage/*' element={<Manage />} />
      <Route path='/*' element={<Index />} />
      <Route element={<Index />} />
    </Routes>
  </BrowserRouter>,
);
